import { AxiosProgressEvent } from "axios";

import { fetcher } from "helpers/fetcher";

import { TAddTicketAttachmentReq, TAddTicketAttachmentRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addTicketAttachment = async (
  payload: TAddTicketAttachmentReq,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
) => {
  return await fetcher<
    TAddTicketAttachmentRes,
    TAddTicketAttachmentReq["data"]
  >(ENDPOINT.MANAGEMENT.ADD_TICKET_ATTACHMENT, {
    data: payload.data,
    fileFields: ["file"],
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.ADD_TICKET_ATTACHMENT.version,
      [API_HEADER.BU_ID]: payload.idBu,
    },
    onUploadProgress: (progressEvent) => {
      if (onUploadProgress) onUploadProgress(progressEvent);
    },
  });
};
